export function pluralDaysAfterTo(number) {
    const lastTwo = number % 100;
    const last = number % 10;

    if (last === 1 && lastTwo !== 11) {
        return 'CALCULATOR_FULL_TILL_DAYS'; // дня
    }

    return 'CALCULATOR_FULL_TILL_DAYS_01'; // днів
}
